<mat-expansion-panel
  [expanded]="expanded"
  class="info-panel remove-mat-expansion-panel-padding">

  <mat-expansion-panel-header>
    <mat-panel-title>

      <div class="section-header-container">
        <p class="grey1 semibold section-title">
          <span class="overline">{{ header | uppercase }}</span>
          @if (recipients.value.length > 0) {
            <span class="grey3 caption"> - {{ recipients.value.length }} {{sysText.selected}}</span>
          }
        </p>

        <mat-divider class="section-header-underline" aria-hidden="true"></mat-divider>
      </div>

    </mat-panel-title>
  </mat-expansion-panel-header>

  <div class="recipient-box-container">
    <div class="recipient-box">
      <p class="body2 semibold to-label">{{ recipientBoxLabel }}:</p>

      <div class="chip-container">
        @for(recipient of recipients.value; track recipient){
          <span class="contact-chip">
            <span class="chip-text body2">
              <span>{{ recipient.title }}</span>
              @if (recipient.companyName != null) {
                <span> &bull;&nbsp;{{ recipient.companyName }}</span>
              }
              @if (recipient.emailAddressTypeId != null) {
                <span> &bull;&nbsp;{{ sysText["emailAddressType" + recipient.emailAddressTypeId] }}</span>
              }
            </span>

            <button type="button" class="button-reset" [attr.aria-label]="sysText.remove_ariaLabel" (click)="onRemoveRecipient(recipient)">
              <mat-icon class="remove-icon">
                close
              </mat-icon>
            </button>
          </span>
        }
      </div>

      @if (usingDefaults) {
        <!-- a toggletip: "using default options" is its name and its tooltip -->
        <button
          type="button"
          class="button-reset toggletip recipients-using-defaults-button"
          [attr.aria-label]="sysText.usingDefaultOptions"
          [matTooltip]="sysText.usingDefaultOptions">
          <mat-icon class="recipients-using-defaults-icon">settings_applications</mat-icon>
        </button>
      }
    </div>

    <div aria-live="polite">
      @if (formGroup.errors?.msError) {
        <mat-error class="mse-form-error caption">
          {{ formGroup.errors?.msError }}
        </mat-error>
      }
    </div>
  </div>

  <div class="select-container">
    <mat-icon [ngClass]="{ focus: select.focused }">contact_mail</mat-icon>

    <mat-form-field color="accent">
      <mat-label>{{ sysText.recipientTypes }}</mat-label>

      <mat-select
        #select="matSelect"
        [formControl]="recipientTypeAdd"
        multiple
        (selectionChange)="onClickRecipientType($event)"
        panelWidth="fit-content">

        <mat-select-trigger>
          @if (recipientTypeAdd.value?.length >= 1) {
            <span>
              @for(rcid of recipientTypeAdd.value; track rcid; let i = $index) {
                <span>
                  <span>{{ getRecipientTypeOptionName(rcid) }}</span>
                  @if (getRecipientTypeOptionEmailAddressTypeId(rcid) != null) {
                    <span> &bull;&nbsp;{{ sysText["emailAddressType" + getRecipientTypeOptionEmailAddressTypeId(rcid)] }}</span>
                  }
                  @if (i < recipientTypeAdd.value?.length - 1) {
                    <span>, </span>
                  }
                </span>
              }
            </span>
          }
        </mat-select-trigger>

        @for(recipientTypeOption of dialogData.recipientTypeOptions; track recipientTypeOption) {
          <mat-option [value]="recipientTypeOption.id + '.' + recipientTypeOption.emailAddressTypeId">
            @let isDefaultOption = recipientTypeOption.id == this.defaultRecipientTypeId || recipientTypeOption.id == this.defaultAdditionalRecipientTypeId;
            @if (isDefaultOption) {
              <mat-icon class="recipient-type-using-defaults-icon" matTooltip="{{sysText.defaultOption}}">settings_applications</mat-icon>
            }
            <span>{{ recipientTypeOption.name }}</span>
            @if (recipientTypeOption.emailAddressTypeId != null) {
              <span> &bull;&nbsp;{{ sysText["emailAddressType" + recipientTypeOption.emailAddressTypeId] }}</span>
            }
            <p class="caption grey3">{{ recipientTypeOption.description }}</p>
            @if (isDefaultOption) {
              <!-- inside an option the icon can't be a button: its meaning is hidden text, read with the option (last,
              so typing the start of a name still finds the option) -->
              <span class="cdk-visually-hidden">{{ sysText.defaultOption }}</span>
            }
          </mat-option>
        }
      </mat-select>

      <!-- mat hint for spacing -->
      <mat-hint></mat-hint>
      <mat-error></mat-error>
    </mat-form-field>
  </div>

  <app-autocomplete-field
    [control]="employeeAdd"
    [icon]="'account_circle'"
    [label]="sysText.specificEmployee"
    [options]="dialogData.employeeEmailOptions"
    [showSearchIcon]="true"
    (optionSelect)="onAddEmployee()">
  </app-autocomplete-field>

  <div class="add-email-container">
    <!-- Enter in the field adds the address, like the add button -->
    <app-input-field
      class="add-email-field"
      [control]="emailAddressAdd"
      [icon]="'alternate_email'"
      [label]="sysText.additionalEmailAddress"
      (keydown.enter)="onAddEmail()">
    </app-input-field>

    <button
      type="button"
      mat-icon-button
      [attr.aria-label]="sysText.add_ariaLabel"
      (click)="onAddEmail()"
      class="add-button">
      <mat-icon class="button-icon">add_circle</mat-icon>
    </button>
  </div>
</mat-expansion-panel>